
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import * as Pedidos from '@lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;

        @Prop( { type: Pedidos.Tipos } )
        public value: Pedidos.Tipos;
        @Watch( 'value', { immediate: true } )
        onIndex()
        {
            this.Selected = this.value;
        }


        @Prop()
        public Tipo: 'todos' | 'plataforma';
        @Watch( 'Tipo', { immediate: true } )
        onTipo()
        {
            if ( this.Tipo == 'plataforma' )
                this.items = Pedidos.Tipos.Plataformas;

            else
                this.items = Pedidos.Tipos.Options;
        }




        public items: Array<Pedidos.Tipos> = Pedidos.Tipos.Options;

        public selected: Pedidos.Tipos | null = null;
        public get Selected(): Pedidos.Tipos | null
        {
            return this.selected;
        }
        public set Selected( x: Pedidos.Tipos | null )
        {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any )
        {

        }
    }
